module.exports = __webpack_public_path__ + "media/images/vp/icon.index.organizations-00a90936b379ccbbffe18e2c00f823e4.svg";